module.exports = "<mat-dialog-content>\n    <h3 class=\"text-sm-center\">\n        <span style=\"font-weight:normal;\">Se eliminará el registro</span>\n        {{deleteString}}\n    </h3>\n    <br>\n</mat-dialog-content>\n\n<mat-dialog-actions>\n    <button mat-raised-button color=\"primary\" mat-dialog-close (click)=\"confirm()\">Confirmar</button>\n\n    <button mat-button color=\"secondary\" (click)=\"cancel()\">Cancelar</button>\n</mat-dialog-actions>"


//////////////////
// WEBPACK FOOTER
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/modules/dialog.confirm.html
// module id = ../../../../../src/app/shared/modules/dialog.confirm.html
// module chunks = main